"use client"

interface CancelPlanModalProps {
  isOpen: boolean
  onClose: () => void
  onCancelPlan: () => void
}

export function CancelPlanModal({ isOpen, onClose, onCancelPlan }: CancelPlanModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4 p-6">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-xl font-bold"
        >
          ×
        </button>

        {/* Content */}
        <div className="space-y-6">
          <h2 className="text-xl font-semibold text-center text-gray-900">¿Estás seguro que quieres cancelar tu plan con Fluxi?
          </h2>

          {/* <p className="text-gray-600 text-center">¿Qué te gustaría hacer con tu plan actual?</p> */}

          <div className="flex items-center justify-center gap-2">
            <div className="flex items-center justify-center gap-2 w-full">
              <button onClick={onClose} className="w-full border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 font-medium py-3 rounded-lg">
                Me quedo con Fluxi
              </button>
            </div>
            <button
              onClick={onCancelPlan}
              className="w-full border border-red-600 bg-white text-red-600 hover:bg-red-50 font-medium py-3 rounded-lg"
            >
              Cancelar mi plan
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
